import React from 'react';
import './gamecard.css';

export default function GameCard({ game }) {
  return (
    <div className="game-card">
      <div className="game-card-left">
        <div className="game-icon" aria-hidden>
          {game.icon ? <img src={game.icon} alt={`${game.title} icon`} /> : <div className="placeholder">🎮</div>}
        </div>
      </div>
      <div className="game-card-right">
        <h3>{game.title}</h3>
        <p className="game-desc">{game.description}</p>
        <div className="store-buttons">
          {game.googleUrl && (
            <a className="store-button google" href={game.googleUrl} target="_blank" rel="noreferrer">
              <img src="/google-play-badge.png" alt="Get it on Google Play" />
            </a>
          )}
          {game.appleUrl && (
            <a className="store-button apple" href={game.appleUrl} target="_blank" rel="noreferrer">
              <img src="/app-store-badge.svg" alt="Download on the App Store" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
